export default __webpack_public_path__ + "static/media/imagen1.80c55c39.jpg";